export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const SELECT_PRODUCTS_ARRAY = 'SELECT_PRODUCTS_ARRAY';
export const DELETE_ALL = 'DELETE_ALL';

export const REFRESH_LIST_VIEW = 'REFRESH_LIST_VIEW';
